var map = {
	"./ch/Chef.json": "fc62",
	"./ch/Common.json": "7135",
	"./en/Chef.json": "2a9c",
	"./en/Common.json": "6d32",
	"./en/Core/Footer.json": "24b2",
	"./en/Core/Toolbar.json": "8d11"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b933";